import { render, staticRenderFns } from "./OfferLetterTemplate.vue?vue&type=template&id=8d574c72&scoped=true"
import script from "./OfferLetterTemplate.vue?vue&type=script&lang=js"
export * from "./OfferLetterTemplate.vue?vue&type=script&lang=js"
import style0 from "./OfferLetterTemplate.vue?vue&type=style&index=0&id=8d574c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d574c72",
  null
  
)

export default component.exports